/**
 * PDP: softens lazysizes global prefetch once cfg exists.
 * Also on variant:changed — boost featured media slide + next two (+1, +2) for earlier eligibility.
 */
(function () {
  function applyTune() {
    var ls = window.lazySizesT4;
    if (!ls || !ls.cfg) return false;
    var c = ls.cfg;
    if (typeof c.expFactor === 'number' && c.expFactor > 1.35) {
      c.expFactor = 1.35;
    }
    if (typeof c.loadMode === 'number' && c.loadMode > 1) {
      c.loadMode = 1;
    }
    return true;
  }

  if (!applyTune()) {
    document.addEventListener(
      'lazyunveilread',
      function onLazyRead() {
        document.removeEventListener('lazyunveilread', onLazyRead);
        applyTune();
        try {
          if (window.lazySizesT4 && lazySizesT4.loader && lazySizesT4.loader.checkElems) {
            lazySizesT4.loader.checkElems();
          }
        } catch (e) {}
      },
      { passive: true }
    );
  }

  function bindVariantGalleryBoost() {
    function attach() {
      var $ = window.jQuery_T4NT || window.jQuery;
      if (!$ || !$.fn || !$.fn.on) {
        setTimeout(attach, 40);
        return;
      }
      $(document).off('variant:changed.prTier').on('variant:changed.prTier', function (evt) {
        var v =
          evt.currentVariant ||
          (evt.originalEvent &&
            evt.originalEvent.detail &&
            evt.originalEvent.detail.variant);
        if (!v || !v.featured_media || !v.featured_media.id) {
          return;
        }

        var mid = v.featured_media.id;
        var target = document.querySelector(
          '[data-product-single-media-group] [data-product-single-media-wrapper][data-media-id="' +
            mid +
            '"]'
        );
        if (!target) {
          return;
        }

        var root =
          target.closest('[data-t4s-gallery]') ||
          target.closest('[data-product-single-media-group]');
        if (!root) {
          return;
        }

        var slides = root.querySelectorAll(
          '[data-product-single-media-wrapper][data-main-slide]'
        );
        var start = -1;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i] === target) {
            start = i;
            break;
          }
        }
        if (start < 0) {
          return;
        }

        function boostSlide(slide) {
          if (!slide) {
            return;
          }
          var imgs = slide.querySelectorAll('img.lazyloadt4s');
          for (var j = 0; j < imgs.length; j++) {
            imgs[j].setAttribute('data-expand', '160');
          }
        }

        boostSlide(slides[start]);
        boostSlide(slides[start + 1]);
        boostSlide(slides[start + 2]);

        try {
          if (window.lazySizesT4 && lazySizesT4.loader && lazySizesT4.loader.checkElems) {
            lazySizesT4.loader.checkElems();
          }
        } catch (e) {}
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    } else {
      attach();
    }
  }

  bindVariantGalleryBoost();
})();
